/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LadderActivityRules
 */
export interface LadderActivityRules {
    /**
     * 
     * @type {number}
     * @memberof LadderActivityRules
     */
    inactivityDays?: number;
    /**
     * 
     * @type {number}
     * @memberof LadderActivityRules
     */
    decayPerDay?: number;
    /**
     * 
     * @type {number}
     * @memberof LadderActivityRules
     */
    decayFloor?: number;
}

/**
 * Check if a given object implements the LadderActivityRules interface.
 */
export function instanceOfLadderActivityRules(value: object): value is LadderActivityRules {
    return true;
}

export function LadderActivityRulesFromJSON(json: any): LadderActivityRules {
    return LadderActivityRulesFromJSONTyped(json, false);
}

export function LadderActivityRulesFromJSONTyped(json: any, ignoreDiscriminator: boolean): LadderActivityRules {
    if (json == null) {
        return json;
    }
    return {
        
        'inactivityDays': json['inactivityDays'] == null ? undefined : json['inactivityDays'],
        'decayPerDay': json['decayPerDay'] == null ? undefined : json['decayPerDay'],
        'decayFloor': json['decayFloor'] == null ? undefined : json['decayFloor'],
    };
}

export function LadderActivityRulesToJSON(json: any): LadderActivityRules {
    return LadderActivityRulesToJSONTyped(json, false);
}

export function LadderActivityRulesToJSONTyped(value?: LadderActivityRules | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'inactivityDays': value['inactivityDays'],
        'decayPerDay': value['decayPerDay'],
        'decayFloor': value['decayFloor'],
    };
}

